module.exports = __webpack_public_path__ + "static/media/abbey-park.6f58dbbd.png";